import { setErrorMessage, showReferenceFileChoiceAction } from 'actions/mainView'
import { TranslationContext } from 'contexts/TranslationContext'
import { getIncompatibleFileExtensions } from 'incompatibleFileExtensionsMap'
import { isEmpty, noop } from 'lodash'
import { useCallback, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAssets, getSourceFilesByIds } from 'selectors'
import { selectReference } from '~/selectors/select-reference'
import { isVideo } from '~/Util/assets'

// useAddSourceFileToTimeline - for the "+" button and adding by frameTimeCode. DnD uses uselayerDropHandler.
export const useAddSourceFileToTimeline = (action = noop, sourceFileIds = []) => {
  const allAssets = useSelector(getAssets)
  const files = useSelector(state => getSourceFilesByIds(state, sourceFileIds))
  const { id: referenceFile } = useSelector(selectReference)
  const { t } = useContext(TranslationContext)
  const dispatch = useDispatch()

  const isIncompatible = useCallback(() => {
    const timelineExtensions = allAssets.map(asset => asset.filetype)
    const incompatibleExtensionsBySourceFile = files
      .reduce((result, item) => {
        if (isVideo(item)) {
          result.push(getIncompatibleFileExtensions(item.filetype))
        }
        return result
      }, [])
    for (const incompatibleFileExtensions of incompatibleExtensionsBySourceFile) {
      const incompatibleFileExtension = timelineExtensions
        .find(ext => incompatibleFileExtensions.includes(ext))
      if (incompatibleFileExtension) {
        dispatch(
          setErrorMessage(`${t('MESSAGE_BOX_REMOVE_EXISTING')} ${incompatibleFileExtension.toUpperCase()}`)
        )
        return true
      }
    }
    return false
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ sourceFileIds, allAssets ])

  const onAddToTimeline = useCallback(() => {
    if (!isIncompatible()) {
      if (sourceFileIds.length > 1 && (!referenceFile || isEmpty(allAssets))) {
        dispatch(showReferenceFileChoiceAction({
          visibility: true,
          getAction: () => action(sourceFileIds),
        }))
      } else {
        dispatch(action(sourceFileIds))
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ sourceFileIds, referenceFile, allAssets.length ])

  return onAddToTimeline
}
